<div class="merchantlist_main">
   
    <div class="merchant_card d-flex">
        <div class="card_theme d-flex">
            <div>
                <p class="m-0 f-12 fw-500 pb-2">Total Merchants</p>
                <p class="m-0 f-17 fw-500">2133</p>
            </div>
            <div>
                <img src="assets\images\Total-merchant.png" alt="">
            </div>
        </div>
        <div class="card_theme d-flex">
            <div>
                <p class="m-0 f-12 fw-500 pb-2">Active Merchants</p>
                <p class="m-0 f-17 fw-500">723</p>
            </div>
            <div>
                <img src="assets\images\archive.png" alt="">
            </div>
        </div>
        <div class="card_theme d-flex">
            <div>
                <p class="m-0 f-12 fw-500 pb-2">Inactive Merchants</p>
                <p class="m-0 f-17 fw-500">342</p>
            </div>
            <div>
                <img src="assets\images\Total-merchant.png" alt="">
            </div>
        </div>
        <div class="card_theme d-flex">
            <div>
                <p class="m-0 f-12 fw-500 pb-2">Pending Merchants</p>
                <p class="m-0 f-17 fw-500">923</p>
            </div>
            <div>
                <img src="assets\images\archive.png" alt="">
            </div>
        </div>
        <div class="card_theme d-flex">
            <div>
                <p class="m-0 f-12 fw-500 pb-2">New Sign-Ups</p>
                <p class="m-0 f-17 fw-500">23</p>
            </div>
            <div>
                <img src="assets\images\new-signup.png" alt="">
            </div>
        </div>
    </div>
    <div class="list_theme">
        <div class="list_heding">
            <p>Merchant List</p>
        </div>
        <div class="part_two">
            <div class="d-flex left_content flex-wrap">
                <div class="list_datepicker">
                    <div>
                        <label class="f-11 fw-400 mb-1" for="">Datepicker</label>
                    </div>
                    <div (click)="dateInput.showPicker()">
                        <input type="date" (change)="select($event)" [value]="today"
                            class="date_theme form-control f-12 " style="padding: 9px;" #dateInput>
                    </div>
                </div>
                <div>
                    <div>
                        <label class="f-11 fw-400 mb-1" for="">Status</label>
                    </div>
                    <select class=" date_theme form-select text-start">
                        <option value="0">All Cash Drawers</option>
                        <option value="1">All Cash Drawers</option>
                        <option value="2">All Cash Drawers</option>
                        <option value="3">All Cash Drawers</option>
                    </select>
                </div>
            </div>
            <div class="merchant_btn d-flex">
                <div class="position-relative">
                    <input type="search" class="search_theme" placeholder="Search Merchants…">
                    <i class="fa-sharp fa-solid fa-magnifying-glass position-absolute search_icon"></i>
                </div>
                <button class="merchant_theme f-12 fw-500 d-flex" (click)="OpenWeekendModel()"><i
                        class="fa-sharp fa-solid fa-plus"></i>New
                    Merchant</button>
            </div>
        </div>
        <div class="mt-4 merchant_table">
            <table id="basic-datatable"
                class="table dt-responsive nowrap error_table no-footer dtr-inline pure-table pure-table-horizontal merchant">
                <thead class="table_header">
                    <tr class="table_top f-14 fw-600">
                        <th></th>
                        <th>Restaurant Name</th>
                        <th class="text-center">Contact Info</th>
                        <th class="text-center">Plan</th>
                        <th class="text-center">Subscriptions</th>
                        <th class="text-center">Exp Date</th>
                        <th class="text-center">Hardware</th>
                        <th class="text-center">menu status</th>
                        <th class="text-center">Status</th>
                    </tr>
                </thead>
                <tbody class="fw-500">
                    <tr>
                        <td>
                            <div class="profile_theme">A</div>
                        </td>
                        <td>
                            <p class="m-0 f-14 fw-600 grey_two">Aaron’s Café</p>
                            <p class="m-0 f-11 fw-400 text_grey">Cafe</p>
                        </td>
                        <td class="text-center">
                            <p class="grey_two m-0 f-11 fw-600">aarons.cafe@abc.com</p>
                            <p class="grey_two m-0 f-11 fw-600">+1 (415) 613 5322</p>
                        </td>
                        <td class="grey_two f-14 text-center fw-600">eatOS Silver</td>
                        <td class="grey_two f-14 text-center fw-600">5</td>
                        <td class="grey_two f-14 text-center fw-600">05 / 15 / 21</td>
                        <td class="grey_two f-14 text-center fw-600">POS, CFD, Kiosk, KDS</td>
                        <td class="grey_two f-14 text-center fw-600">Progress</td>
                        <td class="grey_two f-14 text-center fw-600">Active</td>
                        <td>
                            <div class="gap-1 d-flex justify-content-end align-items-center">
                                <div ngbDropdown container="body">
                                    <div class="cursor-pointer" ngbDropdownToggle>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </div>
                                    <div ngbDropdownMenu>
                                        <button ngbDropdownItem>
                                            View Merchant
                                        </button>
                                        <button ngbDropdownItem >
                                            View Menu
                                        </button>
                                        <button ngbDropdownItem>
                                            Archive
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="profile_theme">A</div>
                        </td>
                        <td>
                            <p class="m-0 f-14 fw-600 grey_two">Aaron’s Café</p>
                            <p class="m-0 f-11 fw-400 text_grey">Cafe</p>
                        </td>
                        <td class="text-center">
                            <p class="grey_two m-0 f-11 fw-600">aarons.cafe@abc.com</p>
                            <p class="grey_two m-0 f-11 fw-600">+1 (415) 613 5322</p>
                        </td>
                        <td class="grey_two text-center f-14 fw-600">eatOS Silver</td>
                        <td class="grey_two text-center f-14 fw-600">5</td>
                        <td class="grey_two text-center f-14 fw-600">05 / 15 / 21</td>
                        <td class="grey_two text-center f-14 fw-600">POS, CFD, Kiosk, KDS</td>
                        <td class="grey_two text-center f-14 fw-600">Progress</td>
                        <td class="grey_two text-center f-14 fw-600">Active</td>
                        <td class="text-center">
                            <div class="gap-1 d-flex justify-content-end align-items-center">
                                <div ngbDropdown container="body">
                                    <div class="cursor-pointer" ngbDropdownToggle>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </div>
                                    <div ngbDropdownMenu>
                                        <button ngbDropdownItem>
                                            View Merchant
                                        </button>
                                        <button ngbDropdownItem>
                                            View Menu
                                        </button>
                                        <button ngbDropdownItem>
                                            Archive
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="profile_theme">A</div>
                        </td>
                        <td>
                            <p class="m-0 f-14 fw-600 grey_two">Aaron’s Café</p>
                            <p class="m-0 f-11 fw-400 text_grey">Cafe</p>
                        </td>
                        <td class="text-center">
                            <p class="grey_two m-0 f-11 fw-600">aarons.cafe@abc.com</p>
                            <p class="grey_two m-0 f-11 fw-600">+1 (415) 613 5322</p>
                        </td>
                        <td class="grey_two text-center f-14 fw-600">eatOS Silver</td>
                        <td class="grey_two text-center f-14 fw-600">5</td>
                        <td class="grey_two text-center f-14 fw-600">05 / 15 / 21</td>
                        <td class="grey_two text-center f-14 fw-600">POS, CFD, Kiosk, KDS</td>
                        <td class="grey_two text-center f-14 fw-600">Progress</td>
                        <td class="grey_two text-center f-14 fw-600">Active</td>
                        <td class="text-center">
                            <div class="gap-1 d-flex justify-content-end align-items-center">
                                <div ngbDropdown container="body">
                                    <div class="cursor-pointer" ngbDropdownToggle>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </div>
                                    <div ngbDropdownMenu>
                                        <button ngbDropdownItem>
                                            View Merchant
                                        </button>
                                        <button ngbDropdownItem>
                                            View Menu
                                        </button>
                                        <button ngbDropdownItem>
                                            Archive
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="profile_theme">A</div>
                        </td>
                        <td>
                            <p class="m-0 f-14 fw-600 grey_two">Aaron’s Café</p>
                            <p class="m-0 f-11 fw-400 text_grey">Cafe</p>
                        </td>
                        <td class="text-center">
                            <p class="grey_two m-0 f-11 fw-600">aarons.cafe@abc.com</p>
                            <p class="grey_two m-0 f-11 fw-600">+1 (415) 613 5322</p>
                        </td>
                        <td class="grey_two text-center f-14 fw-600">eatOS Silver</td>
                        <td class="grey_two text-center f-14 fw-600">5</td>
                        <td class="grey_two text-center f-14 fw-600">05 / 15 / 21</td>
                        <td class="grey_two text-center f-14 fw-600">POS, CFD, Kiosk, KDS</td>
                        <td class="grey_two text-center f-14 fw-600 Uploaded">Uploaded</td>
                        <td class="grey_two text-center f-14 fw-600 delete">Active</td>
                        <td class="text-center">
                            <div class="gap-1 d-flex justify-content-end align-items-center">
                                <div ngbDropdown container="body">
                                    <div class="cursor-pointer" ngbDropdownToggle>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </div>
                                    <div ngbDropdownMenu>
                                        <button ngbDropdownItem>
                                            View Merchant
                                        </button>
                                        <button ngbDropdownItem>
                                            View Menu
                                        </button>
                                        <button ngbDropdownItem>
                                            Archive
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="profile_theme">A</div>
                        </td>
                        <td>
                            <p class="m-0 f-14 fw-600 grey_two">Aaron’s Café</p>
                            <p class="m-0 f-11 fw-400 text_grey">Cafe</p>
                        </td>
                        <td class="text-center">
                            <p class="grey_two m-0 f-11 fw-600">aarons.cafe@abc.com</p>
                            <p class="grey_two m-0 f-11 fw-600">+1 (415) 613 5322</p>
                        </td>
                        <td class="grey_two text-center f-14 fw-600">eatOS Silver</td>
                        <td class="grey_two text-center f-14 fw-600">5</td>
                        <td class="grey_two text-center f-14 fw-600">05 / 15 / 21</td>
                        <td class="grey_two text-center f-14 fw-600">POS, CFD, Kiosk, KDS</td>
                        <td class="grey_two text-center f-14 fw-600 Rejected">Rejected</td>
                        <td class="grey_two text-center f-14 fw-600">Active</td>
                        <td class="text-center">
                            <div class="gap-1 d-flex justify-content-end align-items-center">
                                <div ngbDropdown container="body">
                                    <div class="cursor-pointer" ngbDropdownToggle>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </div>
                                    <div ngbDropdownMenu>
                                        <button ngbDropdownItem>
                                            View Merchant
                                        </button>
                                        <button ngbDropdownItem>
                                            View Menu
                                        </button>
                                        <button ngbDropdownItem>
                                            Archive
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-between align-items-center">
                <div class="f-14">
                    <div ngbDropdown class="d-inline-block me-2 text-black">
                        <button type="button" class="btn f-12 fw-500 sec-btn" id="dropdownBasic1" ngbDropdownToggle>
                            10 <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down"
                                width="16" height="16" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                                fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button ngbDropdownItem>100</button>
                            <button ngbDropdownItem>50</button>
                            <button ngbDropdownItem>20</button>
                        </div>
                    </div>
                    entries per page
                </div>
                <div class="f-14 fw-400 text-black text-end">
                    Showing 1 to 25 of 530 entries
                </div>
                <div>
                    <ngb-pagination class="merchant_pagination" [collectionSize]="1" [(page)]="page" [maxSize]="2"
                        [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #WeekendModel let-c="close" let-d="dismiss" class="">
    <div class="weekend">
        <div class="modal-body p-4">
            <div class="d-flex justify-content-between">
                <div class="f-20 fw-600">
                    Weekend Menu
                </div>
                <div>
                    <img src="assets\images\closeIcon.svg" class="" (click)="d('Cross click');" />
                </div>
            </div>
            <div class="weekend_content w-100">
                <div>
                    <p class="f-16 fw-500 m-0 pt-2">Uploaded Source</p>
                    <div class="left_part">
                        <div class="menu_img position-relative">
                            <img src="assets/images/dinner-menu.png" width="100%" alt="">
                            <i class="fa-regular fa-magnifying-glass-plus position-absolute search_icon" (click)="OpenDinerMenuModel()"></i>
                        </div>
                    </div>
                    <div class="content_part pt-3">
                        <p class="f-16 fw-500 m-0">Content</p>
                        <div class="pt-3">
                            <h6 class="f-16 fw-600 align-items-center d-flex"><input class="checkbox_theme"
                                    type="checkbox">Category</h6>
                            <ul class="m-2">
                                <li class="f-16 fw-600 align-items-center d-flex py-1"><input class="checkbox_theme"
                                        type="checkbox">Product name</li>
                                <li class="f-16 fw-600 align-items-center d-flex py-1"><input class="checkbox_theme"
                                        type="checkbox">Product price</li>
                                <li class="f-16 fw-600 align-items-center d-flex py-1"><input class="checkbox_theme"
                                        type="checkbox">Product description</li>
                            </ul>
                            <h6 class="align-items-center d-flex f-16 fw-600"><input class="checkbox_theme"
                                    type="checkbox">Notes (if any)</h6>
                        </div>
                    </div>
                    <div class="Rescan_btn">
                        <button class="Rescan_theme f-18 fw-500 bg-white">Rescan</button>
                    </div>
                </div>
                <div class="w-100">
                    <div class="right_heading">
                        <p class="f-16 m-0 fw-500 pt-2">Output Menu</p>
                    </div>
                    <div class="menu_content w-100">
                        <div class="d-flex justify-content-between align-items-start w-100 sec_one">
                            <div>
                                <div><label for="" class="m-0 f-14 fw-500">Menu Name</label></div>
                                <input type="text" class="fild_theme" placeholder="Dinner Menu">
                            </div>
                            <div class="view_btn align-items-center">
                                <button class=" bg-white border-0 f-14 fw-500" (click)="OpenViewmenuModel()">Quick View</button>
                                 <p (click)="eyshowhide()" class="m-auto"><i  *ngIf="!showeyes" class="fa-solid fa-eye"></i><i  *ngIf="showeyes" class="fa-sharp fa-solid fa-eye-slash"></i></p>
                            </div>
                        </div>
                        <div class="category_part">
                            <div class="d-flex gap-3 align-items-center justify-content-between">
                                <div class="d-flex align-items-center gap-3">
                                    <div>
                                        <img src="assets\images\category-mark.png" class="mart_img" alt="">
                                    </div>
                                    <div>
                                        <div><label for="" class="m-0 f-14 fw-500">Category Name</label></div>
                                        <input type="text" class="fild_theme" placeholder="Dinner Menu">
                                    </div>
                                </div>
                                <div class="gap-1 d-flex justify-content-end align-items-center">
                                    <div ngbDropdown container="body">
                                        <div class="cursor-pointer" ngbDropdownToggle>
                                            <i class="fas fa-ellipsis-v"></i>
                                        </div>
                                        <div ngbDropdownMenu>
                                            <button ngbDropdownItem>
                                                Delete Category
                                            </button>
                                            <button ngbDropdownItem>
                                                Add Note
                                            </button>
                                            <button ngbDropdownItem>
                                                Add Product
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="category_detalis">
                                <div>
                                    <div class="d-flex gap-3 align-items-center pt-2">
                                        <div>
                                            <img src="assets\images\category-mark.png" class="mart_img" alt="">
                                        </div>
                                        <div class="d-flex gap-3 w-100 align-items-center input_part">
                                            <div class="w-100">
                                                <div><label for="" class="m-0 f-14 fw-500">Product name</label></div>
                                                <input type="text" class="fild_theme_two" placeholder="appetizers">
                                            </div>
                                            <div>
                                                <div><label for="" class="m-0 f-14 fw-500">Product price</label></div>
                                                <input type="text" class="fild_theme" placeholder="Dinner Menu">
                                            </div>
                                            <div>
                                                <i class="fa-regular fa-trash-can f-20 delete_icon pt-4"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="padding: 0px 24px;" class="pt-2">
                                        <div><label for="" class="m-0 f-14 fw-500">Product Description</label></div>
                                        <input type="text" class="fild_theme_two">
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex gap-3 align-items-center pt-2">
                                        <div>
                                            <img src="assets\images\category-mark.png" class="mart_img" alt="">
                                        </div>
                                        <div class="d-flex gap-3 w-100 align-items-center input_part">
                                            <div class="w-100">
                                                <div><label for="" class="m-0 f-14 fw-500">Product Name</label></div>
                                                <input type="text" class="fild_theme_two" placeholder="product name">
                                            </div>
                                            <div>
                                                <div><label for="" class="m-0 f-14 fw-500">Product Price</label></div>
                                                <input type="text" class="fild_theme" placeholder="$ 20.00">
                                            </div>
                                            <div>
                                                <i class="fa-regular fa-trash-can f-20 delete_icon pt-4"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="padding: 0px 24px;" class="pt-2">
                                        <div><label for="" class="m-0 f-14 fw-500">Product Description</label></div>
                                        <input type="text" class="fild_theme_two">
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex gap-3 align-items-center pt-2">
                                        <div>
                                            <img src="assets\images\category-mark.png" class="mart_img" alt="">
                                        </div>
                                        <div class="d-flex gap-3 w-100 align-items-center input_part">
                                            <div class="w-100">
                                                <div><label for="" class="m-0 f-14 fw-500">Product Name</label></div>
                                                <input type="text" class="fild_theme_two"
                                                    placeholder="Crispy fried cheese (V)">
                                            </div>
                                            <div>
                                                <div><label for="" class="m-0 f-14 fw-500">Product Price</label></div>
                                                <input type="text" class="fild_theme" placeholder="$ 20.00">
                                            </div>
                                            <div>
                                                <i class="fa-regular fa-trash-can f-20 delete_icon pt-4"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="padding: 0px 24px;" class="pt-2">
                                        <div><label for="" class="m-0 f-14 fw-500">Product Description</label></div>
                                        <input type="text" class="fild_theme_two">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="category_part">
                            <div class="d-flex gap-3 align-items-center justify-content-between">
                                <div class="d-flex align-items-center gap-3">
                                    <div>
                                        <img src="assets\images\category-mark.png" class="mart_img" alt="">
                                    </div>
                                    <div>
                                        <div><label for="" class="m-0 f-14 fw-500">Category Name</label></div>
                                        <input type="text" class="fild_theme" placeholder="Dinner Menu">
                                    </div>
                                </div>
                                <div class="gap-1 d-flex justify-content-end align-items-center">
                                    <div ngbDropdown container="body">
                                        <div class="cursor-pointer" ngbDropdownToggle>
                                            <i class="fas fa-ellipsis-v"></i>
                                        </div>
                                        <div ngbDropdownMenu>
                                            <button ngbDropdownItem>
                                                Delete Category
                                            </button>
                                            <button ngbDropdownItem>
                                                Add Note
                                            </button>
                                            <button ngbDropdownItem>
                                                Add Product
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="category_detalis">
                                <div>
                                    <div class="d-flex gap-3 align-items-center pt-2">
                                        <div>
                                            <img src="assets\images\category-mark.png" class="mart_img" alt="">
                                        </div>
                                        <div class="d-flex gap-3 w-100 align-items-center input_part">
                                            <div class="w-100">
                                                <div><label for="" class="m-0 f-14 fw-500">Product Name</label></div>
                                                <input type="text" class="fild_theme_two" placeholder="appetizers">
                                            </div>
                                            <div>
                                                <div><label for="" class="m-0 f-14 fw-500">Product Price</label></div>
                                                <input type="text" class="fild_theme" placeholder="Dinner Menu">
                                            </div>
                                            <div>
                                                <i class="fa-regular fa-trash-can f-20 delete_icon pt-4"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="padding: 0px 24px;" class="pt-2">
                                        <div><label for="" class="m-0 f-14 fw-500">Product Description</label></div>
                                        <input type="text" class="fild_theme_two">
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex gap-3 align-items-center pt-2">
                                        <div>
                                            <img src="assets\images\category-mark.png" class="mart_img" alt="">
                                        </div>
                                        <div class="d-flex gap-3 w-100 align-items-center input_part">
                                            <div class="w-100">
                                                <div><label for="" class="m-0 f-14 fw-500">Product Name</label></div>
                                                <input type="text" class="fild_theme_two" placeholder="product name">
                                            </div>
                                            <div>
                                                <div><label for="" class="m-0 f-14 fw-500">Product Price</label></div>
                                                <input type="text" class="fild_theme" placeholder="$ 20.00">
                                            </div>
                                            <div>
                                                <i class="fa-regular fa-trash-can f-20 delete_icon pt-4"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="padding: 0px 24px;" class="pt-2">
                                        <div><label for="" class="m-0 f-14 fw-500">Product Description</label></div>
                                        <input type="text" class="fild_theme_two">
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex gap-3 align-items-center pt-2">
                                        <div>
                                            <img src="assets\images\category-mark.png" class="mart_img" alt="">
                                        </div>
                                        <div class="d-flex gap-3 w-100 align-items-center input_part">
                                            <div class="w-100">
                                                <div><label for="" class="m-0 f-14 fw-500">Product Name</label></div>
                                                <input type="text" class="fild_theme_two"
                                                    placeholder="Crispy fried cheese (V)">
                                            </div>
                                            <div>
                                                <div><label for="" class="m-0 f-14 fw-500">Product Price</label></div>
                                                <input type="text" class="fild_theme" placeholder="$ 20.00">
                                            </div>
                                            <div>
                                                <i class="fa-regular fa-trash-can f-20 delete_icon pt-4"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="padding: 0px 24px;" class="pt-2">
                                        <div><label for="" class="m-0 f-14 fw-500">Product Description</label></div>
                                        <input type="text" class="fild_theme_two">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>


<ng-template #ViewmenuModel let-c="close" let-d="dismiss" class="">
    <div class="model_verify">
        <div class="modal-body p-0">
            <div class="d-flex modal_heading justify-content-between">
                <div class="f-20 f-14 fw-600">
                    Dinner Menu
                </div>
                <div class="d-flex modal_heading justify-content-end position-fixed close_icon">
                    <div>
                        <i class="fa-solid fa-xmark text-white close" (click)="d('Cross click');"></i>
                    </div>
                </div>
            </div>
            <div class="view_content text-black">
                <div>
                    <h6 class="f-14 fw-500 pb-1">Appetizers</h6>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Soup of the day Baked fingerling potatoes (V)</p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Crispy fried cheese (V)</p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>House Salad (v)</p>
                        <p>$ 20</p>
                    </div>
                </div>
                <div class="pt-3">
                    <h6 class="f-14 pb-1 fw-500">Salads</h6>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Caesar salad </p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Feta salad (V)</p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Marinated salmon salad</p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500"><p>Vegan Kale salad (V)</p><p>$ 20</p></div>
                </div>
                <div class="pt-3">
                    <h6 class="f-14 pb-1 fw-500">Pastas </h6>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Vegan lasagna (MV)</p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Spaghetti pomodoro (v) </p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Farfale with shrimp and zucchini</p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500"><p>Vegan Kale salad (V)</p><p>$ 20</p></div>
                </div>
                <div class="pt-3">
                    <h6 class="f-14 pb-1 fw-500">Specialties </h6>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Crispy chicken with mango sauce Fresh grilled beef</p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Tofu butternut curry (M) Poached eggs in avocado toasts (V)
                        </p>
                        <p>$ 20</p>
                    </div>
                </div>
                <div class="pt-3">
                    <h6 class="f-14 pb-1 fw-500">Sidek choose from salad french med sweet potato fries, or rice</h6>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Desserts</p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Red fruits cheesecake</p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Tiramisu</p>
                        <p>$ 20</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between f-14 fw-500">
                        <p>Triple chocolate cake Bowl of ice-cream</p>
                        <p>$ 20</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #DinerMenuModel let-c="close" let-d="dismiss" class="">
    <div class="model_verify p-0">
        <div class="modal-body p-0">
            <div class="d-flex modal_heading justify-content-end position-fixed close_icon">
                <div>
                    <i class="fa-solid fa-xmark text-white close" (click)="d('Cross click');"></i>
                </div>
            </div>
        </div>
        <div>
         <img src="assets\images\dinner-menu2.png" width="100%" alt="">
        </div>
    </div>
</ng-template>